module.exports = __webpack_public_path__ + "img/vue2-doublure_gris.9899ccab.png";